import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Trusts & Legal Entities',
		url: '/legal_entities',
		icon: 'handshake-o',
	}
];

export default class Legal_Entities extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-legal_entity" onClick={this.toggle('modalLegalEntity')} size="sm" color="primary">
						<i className="fa fa-handshake-o"/>&nbsp;&nbsp;Add Trust/Legal Entity
					</Button>
				</Framework.Components.PageBar>

				<Collections.LegalEntities
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Legal Entity"
					object={Objects.LegalEntity}
					history={this.props.history}
					toggle={this.state['modalLegalEntity']}
					reportClose={this.reportClose('modalLegalEntity')}
					afterSave={this.handleAfterSave}
					url="legal_entities"
				/>

			</div>
		)
	}
}


